export const MY_API_BASE = `${process.env.NEXT_PUBLIC_BASE_URL_MY || ''}/api`;

export const MY_QUERY_KEYS = {
  childDetails: 'childDetails',
  childAvailability: 'childAvailability',
} as const;
